<div class="reporting-container">
  <button type="button" class="reporting-close" (click)="closeModal()" [disabled]="reporting">
    <img src="assets/icons/icon-close.svg" alt="Close" />
  </button>

  <div class="reporting-icon" aria-hidden="true">
    <svg viewBox="0 0 24 24" width="26" height="26" fill="none">
      <path d="M12 3 1.5 21h21L12 3Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
      <path d="M12 9.5v5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
      <circle cx="12" cy="17" r="1" fill="currentColor" />
    </svg>
  </div>

  <div class="title-section">
    <h3 class="title">Reporting</h3>
    <h4 class="subtitle">
      <span class="module-name">{{ moduleName || 'Creator' }}</span> by
      <span class="creator-name">{{ contentCreator || 'Creator' }}</span>
    </h4>
  </div>

  <form [formGroup]="reportingForm" (ngSubmit)="onSubmit()" class="reporting-form">
    <div class="reason-section">
      <label class="reason-label" for="reporting-reason">Reason</label>
      <textarea
        id="reporting-reason"
        class="reason-textarea"
        [class.is-invalid]="submitted && f['reason'].errors"
        formControlName="reason"
        placeholder="Enter your reason here (minimum 10 characters)..."
        rows="6"
      ></textarea>

      @if (submitted && f['reason'].errors) {
        <div class="validation-errors">
          @if (f['reason'].errors['required']) {
            <div class="error-message">Reason is required.</div>
          }
          @if (f['reason'].errors['minlength']) {
            <div class="error-message">Reason must be at least 10 characters long.</div>
          }
          @if (f['reason'].errors['maxlength']) {
            <div class="error-message">Reason cannot exceed 500 characters.</div>
          }
        </div>
      }

      @if (f['reason'].value) {
        <div class="character-counter">{{ f['reason'].value.length }} / 500</div>
      }
    </div>

    <div class="button-section">
      <button type="submit" class="btn btn-danger" [disabled]="(submitted && reportingForm.invalid) || reporting">
        @if (reporting) {
          <span class="reporting-spinner" aria-hidden="true"></span>
          Reporting&hellip;
        } @else {
          Report
        }
      </button>
    </div>
  </form>
</div>
